.pageContainer {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 25px;
  width: 100%;
  gap: 25px;
}

.listingsContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  overflow: hidden;
}

.dontLeaveContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  background-color: var(--sentiment-background-notice);
  border-radius: 12px;
}

.dontLeaveIcon {
  color: var(--sentiment-text-notice);
}

.dontLeaveText {
  color: var(--sentiment-text-notice) !important;
}

.listingContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: var(--static-background-standard);
  padding: 1.25rem;
  gap: 10px;
}

.loaderContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.borderBottom {
  border-bottom: 1px solid var(--static-divider-standard);
}

.leftColContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 0;
  flex: 1;
}

.minWidth0 {
  min-width: 0;
}

.listItemLeftColumn {
  width: 100%;
  min-width: 0;
  padding: 0 0.5rem;
}

.listItemTitle {
  display: block;
  width: 100%;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.rightColContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 5px;
}
